import { useState } from "react";
import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseButton from "../../components/ui/BaseButton";
import CreateEngineerModal from "./CreateEngineerModal";

const WorkersListingHeader = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="border-b border-zinc-300 bg-white">
        <BaseWrapper>
          <div className="py-[7px] flex justify-between items-center">
            <h3 className="font-light">My Workers</h3>
            <BaseButton
              color="primary"
              className="py-[4px] px-[28px]"
              onClick={() => setIsModalOpen(true)}
            >
              Add Engineer
            </BaseButton>
          </div>
        </BaseWrapper>
      </div>
      <CreateEngineerModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default WorkersListingHeader;
